import { Component, inject } from '@angular/core';
import { COMPONENT_VERSIONS } from '@fgb/core';
import { MarketplacePurchaseSuccessV1Component } from './marketplace-purchase-success-v1/marketplace-purchase-success-v1.component';
import { MarketplacePurchaseSuccessV2Component } from './marketplace-purchase-success-v2/marketplace-purchase-success-v2.component';

const componentMap = {
  1: MarketplacePurchaseSuccessV1Component,
  2: MarketplacePurchaseSuccessV2Component,
};

type MarketplaceComponentVersion = keyof typeof componentMap;

/** Container component that delegates rendering to a versioned marketplace component based on COMPONENT_VERSIONS config. */
@Component({
  selector: 'fgb-marketplace-purchase-success-page',
  template: `<ng-container *ngComponentOutlet="component"></ng-container>`,
})
export class MarketplacePurchaseSuccessPageComponent {
  private readonly marketplaceVersion = inject(COMPONENT_VERSIONS)?.marketplace as MarketplaceComponentVersion;

  get component() {
    return componentMap[this.marketplaceVersion || 1]; // default to version 1 if not specified
  }
}
